import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        maxWidth: '500px',
        textAlign: 'center',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ fontSize: '72px', marginBottom: '0', color: '#487fff', fontWeight: 'bold' }}>
          404
        </h1>
        <h2 style={{ fontSize: '20px', color: '#343a40', marginBottom: '12px' }}>
          {t('not_found.title', 'Pagina nao encontrada')}
        </h2>
        <p style={{ color: '#6c757d', marginBottom: '24px', fontSize: '14px' }}>
          {t('not_found.description', 'A pagina que voce esta tentando acessar nao existe ou foi movida.')}
        </p>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            padding: '10px 24px',
            backgroundColor: '#487fff',
            color: '#ffffff',
            border: 'none',
            borderRadius: '8px',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          {t('not_found.back_to_home', 'Voltar ao Inicio')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
